<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="mat-sidenav-icon"
    [ngClass]="{'mat-sidenav-icon': !isMobile , 'mat-sidenav-icon-mobile': isMobile}" fixedInViewport
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'" [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="(isHandset$ | async) === false">
    <div>
      <span *ngIf="!(isHandset$ | async)" class="solv-logo-top-left"> <img src="assets/images/LOGO_NEWTM.svg" /></span>
    </div>
    <div class="applications-left">
      Applications
    </div>
    <!-- <mat-toolbar>
      <img src="assets/images/LOGO_NEWTM.svg" />
    </mat-toolbar> -->
    <mat-nav-list>
      <mat-list-item *ngFor="let applicationStatus of applicationStatuses; let i=index; first as isFirst"
        [ngClass]="{'bil-selecetd-tab': isFirst, 'bil-not-selecetd-tab': !isFirst}">
        <button class="bil-font-regular mat-list-btn" mat-stroked-button>{{applicationStatus}}
        </button>
        <mat-divider class="bil-divider-background"></mat-divider>
      </mat-list-item>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar class="bil-font-small" [ngClass]="{'bil-align-item-end': !(isHandset$ | async)}">
      <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()"
        *ngIf="isHandset$ | async">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <span *ngIf="isHandset$ | async"> <img class="img-diamension" src="assets/images/logo_mark.png" /></span>
      <div class="bil-content-parent padding-20">
        <span class="bil-content-child bil-clickable-item" [matMenuTriggerFor]="menu">
          <img src="../../assets/images/flat.svg" />
        </span>
        <mat-menu #menu="matMenu" xPosition="after">
          <div>
            <button class="bil-font-regular bil-logout-text" mat-menu-item (click)="signOut()">
              <mat-icon>
                <img src="../../assets/images/logout.svg">
              </mat-icon>
              Logout
            </button>
          </div>
        </mat-menu>
        <span class="bil-font-regular bil-content-child bil-right-padding-5 bil-font-faded-blue">
          {{customerName}}
        </span>
      </div>
    </mat-toolbar>
    <div class="mat-content-margin bil-font-medium" *ngIf="percentComplete != 100">Complete your loan
      application</div>
    <div class="mat-content-margin bil-font-black bil-font-xmedium" *ngIf="percentComplete == 100">Your application has
      been submitted
      successfully.
      Click on Track Application to view progress</div>
    <mat-card
      [ngClass]="{'mat-card-dashboard-mobile': isHandset$ | async , 'mat-card-dashboard': !(isHandset$ | async) }">
      <div class="bil-space-between padding-20 bil-mat-card-header">
        <span>
          <span class="bil-font-white bil-font-regular">
            APPLICATION ID:
          </span>
          <span class="bil-font-white bil-font-regular bil-font-weight">
            {{applicationId}}
          </span>
        </span>
        <span class="bil-font-white bil-font-regular">
          Created on <span class="bil-font-weight">{{ createdDate | date : 'dd/MM/yyyy' }}</span>
        </span>
      </div>
      <div class="bil-space-between bil-padding-percent">
        <span style="width: 60%;" [ngClass]="{'width': !(isHandset$ | async), 'width-mobile': (isHandset$ | async)}">
          <span>
            {{ percentComplete }} % <span class="bil-font-faded-black">Completed</span>
          </span>
          <span>
            <mat-progress-bar style="padding-top: 12px" mode="determinate" value="{{ percentComplete }}">
            </mat-progress-bar>
          </span>
        </span>
        <span *ngIf="!(isHandset$ | async)">
          <button id="bil-dashboard-action-button" mat-raised-button style="width: 100% !important" color="primary"
            (click)="resumeApplication()">
            <span *ngIf="applicationData?.progress == 100 || techInfoStatus">
              Track Application
            </span>
            <span *ngIf="applicationData?.progress != 100 && !techInfoStatus">
              Resume Application
            </span>
          </button>
        </span>
      </div>
      <mat-card-content class="bil-mat-card-content">
        <div class="rectangle bil-space-between padding-20">
          <span class="bil-content-parent">
            <span class="bil-icon-text-align">
              <mat-icon mat-list-icon>
                <img src="../../assets/images/check-box-Green.svg" />
              </mat-icon>
            </span>
            <span style="margin-left: 10px;">
              Basic Details
            </span>
          </span>
          <span class="bil-content-parent" *ngIf="applicationData?.basicDetailProgress != 100">
            <a class="bil-font-orange bil-font-weigh bil-clickable-item bil-font-underline"
              (click)="viewBasicDetails()">Edit</a>
          </span>
          <span class="bil-font-uploded-color" *ngIf="applicationData?.basicDetailProgress == 100">
            Completed
          </span>
        </div>
        <div style="margin-top: 2%;" class="rectangle bil-space-between padding-20">
          <span class="bil-content-parent">
            <span class="bil-icon-text-align" *ngIf="applicationData?.documentUploadProgress != 100">
              <mat-icon mat-list-icon>
                <img src="../../assets/images/checkbox_yellow.svg" />
              </mat-icon>
            </span>
            <span class="bil-icon-text-align" *ngIf="applicationData?.documentUploadProgress == 100">
              <mat-icon mat-list-icon>
                <img src="../../assets/images/check-box-Green.svg" />
              </mat-icon>
            </span>
            <span style="margin-left: 10px;">
              Document Upload
            </span>
          </span>
          <span class="bil-content-parent bil-progress-color" *ngIf="applicationData?.documentUploadProgress != 100">
            In Progress
          </span>
          <span class="bil-font-uploded-color" *ngIf="applicationData?.documentUploadProgress == 100">
            Completed
          </span>
        </div>
      </mat-card-content>
      <div *ngIf="isHandset$ | async" class="display-in-center">
        <span>
          <button mat-raised-button style="width: 100% !important" color="primary" (click)="resumeApplication()">
            <span *ngIf="(applicationData?.progress == 100 || techInfoStatus)">
              Track Application
            </span>
            <span *ngIf="(applicationData?.progress != 100 && !techInfoStatus)">
              Resume Application
            </span>
          </button>
        </span>
      </div>
    </mat-card>
  </mat-sidenav-content>
</mat-sidenav-container>